import { z } from 'zod';
import type { MerchantMediaListParams } from './service/types';
import { MEDIA_PAGE_SIZE } from './utils/constants';

export const mediaSearchSchema = z.object({
  page: z.union([z.string(), z.number()]).optional(),
});

export type MediaSearchInput = z.infer<typeof mediaSearchSchema>;

export interface MediaRouteSearch {
  page?: number;
}

function normalizePage(value: MediaSearchInput['page']): number | undefined {
  const parsed = typeof value === 'string' ? Number(value.trim()) : value;
  if (parsed === undefined || !Number.isInteger(parsed) || parsed < 1) return undefined;
  // Page 1 is the default; keep it out of the URL.
  return parsed === 1 ? undefined : parsed;
}

export function normalizeMediaSearch(search: MediaSearchInput): MediaRouteSearch {
  return { page: normalizePage(search.page) };
}

export function areMediaSearchEqual(a: MediaSearchInput, b: MediaRouteSearch): boolean {
  return a.page === b.page;
}

export function mediaLoaderDeps(search: MediaSearchInput): MerchantMediaListParams {
  return {
    page: normalizeMediaSearch(search).page ?? 1,
    page_size: MEDIA_PAGE_SIZE,
  };
}
